import{useEffect,useState}from'react'
import{supabase}from'../supabase'
import DealForm from'./DealForm'
import TicketTiers from'./TicketTiers'
import Contacts from'./Contacts'
import ContractGenerator from'./ContractGenerator'
import Settlement from'./Settlement'
import EmailParser from'./EmailParser'
export default function EventDetail({eventId,onBack,orgId}){
const[event,setEvent]=useState(null)
const[expenses,setExpenses]=useState([])
const[deal,setDeal]=useState(null)
const[tiers,setTiers]=useState([])
const[contacts,setContacts]=useState([])
const[loading,setLoading]=useState(true)
const[newExpense,setNewExpense]=useState({description:'',estimated:''})
const[notes,setNotes]=useState(event?.notes||'')
const[savingNotes,setSavingNotes]=useState(false)
useEffect(()=>{fetchAll()},[])
async function fetchAll(){
const{data:ev}=await supabase.from('events').select('*').eq('id',eventId).single()
const{data:ex}=await supabase.from('expenses').select('*').eq('event_id',eventId)
const{data:dlArr}=await supabase.from('deals').select('*').eq('event_id',eventId)
const{data:tr}=await supabase.from('ticket_tiers').select('*').eq('event_id',eventId)
const{data:co}=await supabase.from('contacts').select('*').eq('event_id',eventId)
setEvent(ev)
setExpenses(ex||[])
setDeal(dlArr&&dlArr.length>0?dlArr[0]:null)
setTiers(tr||[])
setContacts(co||[])
setLoading(false)}
async function applyEmailData(data){
if(data.artist_name||data.event_date){
await supabase.from('events').update({artist_name:data.artist_name||event.artist_name,event_date:data.event_date||event.event_date,notes:data.notes||event.notes}).eq('id',eventId)}
if(data.guarantee_amount){
await supabase.from('deals').upsert({event_id:eventId,deal_type:data.deal_type||'flat_guarantee',guarantee_amount:data.guarantee_amount||0,door_percentage:data.door_percentage||0,travel_covered:data.travel_covered||false,travel_cap:data.travel_cap||0,hospitality_buyout:data.hospitality_buyout||0,comp_tickets:data.comp_tickets||0})}
const newContacts=[]
if(data.agent_name){newContacts.push({event_id:eventId,org_id:'00000000-0000-0000-0000-000000000001',name:data.agent_name,email:data.agent_email||'',company:data.agent_company||'',role:'agent',phone:''})}
if(data.tour_manager_name){newContacts.push({event_id:eventId,org_id:'00000000-0000-0000-0000-000000000001',name:data.tour_manager_name,email:data.tour_manager_email||'',company:'',role:'tour_manager',phone:''})}
if(newContacts.length>0){await supabase.from('contacts').insert(newContacts)}
fetchAll()}
async function saveNotes(){
setSavingNotes(true)
await supabase.from('events').update({notes}).eq('id',eventId)
setSavingNotes(false)}
async function addExpense(){
if(!newExpense.description)return
const{data}=await supabase.from('expenses').insert([{event_id:eventId,description:newExpense.description,estimated:parseFloat(newExpense.estimated)||0,category:'other'}]).select()
setExpenses([...expenses,...data])
setNewExpense({description:'',estimated:''})}
if(loading)return<div className='page'>Loading...</div>
const guarantee=deal?parseFloat(deal.guarantee_amount)||0:0
const travelCap=deal?parseFloat(deal.travel_cap)||0:0
const hospitality=deal?parseFloat(deal.hospitality_buyout)||0:0
const totalExpenses=expenses.reduce((sum,e)=>sum+(parseFloat(e.estimated)||0),0)
const totalCosts=totalExpenses+guarantee+travelCap+hospitality
const capacity=tiers.reduce((sum,t)=>sum+t.quantity,0)
const proj25=tiers.reduce((sum,t)=>sum+(t.price*t.quantity*0.25),0)
const proj50=tiers.reduce((sum,t)=>sum+(t.price*t.quantity*0.5),0)
const proj75=tiers.reduce((sum,t)=>sum+(t.price*t.quantity*0.75),0)
const proj100=tiers.reduce((sum,t)=>sum+(t.price*t.quantity),0)
return(<div>
<div className='header'><h1>Greenroom</h1></div>
<div className='page'>
<button className='btn-back' onClick={onBack}>← Back to events</button>
<button onClick={async()=>{if(window.confirm('Are you sure you want to delete this event? This cannot be undone.')){{await supabase.from('deals').delete().eq('event_id',eventId);await supabase.from('expenses').delete().eq('event_id',eventId);await supabase.from('ticket_tiers').delete().eq('event_id',eventId);await supabase.from('contacts').delete().eq('event_id',eventId);await supabase.from('contracts').delete().eq('event_id',eventId);await supabase.from('settlements').delete().eq('event_id',eventId);await supabase.from('events').delete().eq('id',eventId);onBack()}}}} style={{float:'right',background:'none',border:'1px solid #ffcccc',color:'#cc0000',padding:'6px 14px',borderRadius:'6px',fontSize:'13px',cursor:'pointer'}}>Delete Event</button>
<div className='section'>
<select value={event.status} onChange={async e=>{await supabase.from('events').update({status:e.target.value}).eq('id',eventId);fetchAll()}} style={{fontSize:'11px',textTransform:'uppercase',color:'#1a6b4a',fontWeight:'600',border:'none',background:'none',cursor:'pointer',padding:0}}>
<option value='inquiry'>Inquiry</option>
<option value='confirmed'>Confirmed</option>
<option value='day_of'>Day Of</option>
<option value='settled'>Settled</option>
<option value='archived'>Archived</option>
</select><h1 className='event-name'>{event.name}</h1>
<p className='event-artist'>{event.artist_name} — {event.event_date}</p>
{event.notes&&<p style={{fontSize:'13px',color:'#666',marginTop:'8px',fontStyle:'italic'}}>{event.notes}</p>}
</div>
<Contacts eventId={eventId} contacts={contacts} onSaved={fetchAll} orgId={orgId}/>
<div className='section'><h2>Notes</h2><textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder='Add notes about this event...' style={{width:'100%',minHeight:'100px',padding:'10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px',fontFamily:'inherit',resize:'vertical',boxSizing:'border-box',marginBottom:'8px'}}/><button className='btn-primary' onClick={saveNotes} disabled={savingNotes}>{savingNotes?'Saving...':'Save Notes'}</button></div>
<div className='section'><h2>Deal Terms</h2>
<DealForm eventId={eventId} deal={deal} onSaved={fetchAll}/>
</div>
<div className='section'><h2>Ticket Tiers</h2>
<TicketTiers eventId={eventId} tiers={tiers} onSaved={fetchAll}/>
</div>
<div className='section'><h2>Expenses</h2>
{expenses.map(e=>(<div key={e.id} className='expense-row'><span>{e.description}</span><span>${parseFloat(e.estimated).toFixed(2)}</span></div>))}
<div className='add-expense'>
<input className='input' placeholder='Description' value={newExpense.description} onChange={e=>setNewExpense({...newExpense,description:e.target.value})}/>
<input className='input' placeholder='Amount' value={newExpense.estimated} onChange={e=>setNewExpense({...newExpense,estimated:e.target.value})} style={{width:'120px'}}/>
<button className='btn-primary' onClick={addExpense}>Add</button>
</div></div>
<div className='section'><h2>Import from Email</h2><EmailParser onDataExtracted={applyEmailData}/></div>
<div className='section'><h2>Contract</h2><ContractGenerator event={event} deal={deal} contacts={contacts}/></div>
<div className='section'><h2>Settlement</h2><Settlement event={event} deal={deal} contacts={contacts} tiers={tiers}/></div>
<div className='pl-summary'><h2>P&L Summary</h2>
<div className='pl-row'><span>Artist Guarantee</span><span>-${guarantee.toFixed(2)}</span></div>
<div className='pl-row'><span>Travel Cap</span><span>-${travelCap.toFixed(2)}</span></div>
<div className='pl-row'><span>Hospitality</span><span>-${hospitality.toFixed(2)}</span></div>
<div className='pl-row'><span>Other Expenses</span><span>-${totalExpenses.toFixed(2)}</span></div>
<div className='pl-total'><span>Total Costs</span><span>-${totalCosts.toFixed(2)}</span></div>
<div className='pl-row'><span>Capacity</span><span>{capacity} tickets</span></div>
<div className='pl-row'><span>Gross @ 25%</span><span>${proj25.toFixed(2)}</span></div>
<div className='pl-row'><span>Gross @ 50%</span><span>${proj50.toFixed(2)}</span></div>
<div className='pl-row'><span>Gross @ 75%</span><span>${proj75.toFixed(2)}</span></div>
<div className='pl-row'><span>Gross @ 100%</span><span>${proj100.toFixed(2)}</span></div>
<div className='pl-total'><span>Net @ 25%</span><span>${(proj25-totalCosts).toFixed(2)}</span></div>
<div className='pl-total'><span>Net @ 50%</span><span>${(proj50-totalCosts).toFixed(2)}</span></div>
<div className='pl-total'><span>Net @ 75%</span><span>${(proj75-totalCosts).toFixed(2)}</span></div>
<div className='pl-total'><span>Net @ 100%</span><span>${(proj100-totalCosts).toFixed(2)}</span></div>
</div></div></div>)}